export class InternalArktypeError extends Error {
}
export const throwInternalError = message => throwError(message, InternalArktypeError);
export const throwError = (message, ctor = Error) => {
    throw new ctor(message);
};
export class ParseError extends Error {
    name = "ParseError";
}
export const throwParseError = message => throwError(message, ParseError);
